var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28-5H-4v31.071h32z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1e2640"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.766 4.477H6.944c-1.091 0-1.984-.866-1.984-1.924C4.96 1.495 5.853.63 6.944.63h15.822c1.092 0 1.984.865 1.984 1.923s-.892 1.924-1.984 1.924zM6.994 16.595h15.772c1.092 0 1.984.865 1.984 1.923s-.892 1.923-1.984 1.923H6.944c-1.091 0-1.984-.865-1.984-1.923s.942-1.923 2.034-1.923zM2.034 8.612h20.732c1.092 0 1.984.866 1.984 1.924 0 1.058-.892 1.923-1.984 1.923H1.984C.893 12.46 0 11.594 0 10.536s.942-1.924 2.034-1.924z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.5631c02184b860ce54a1e5dddae3caf9.svg";
export { ForwardRef as ReactComponent };